import type { Category } from '@/types/content';

export const categories: Category[] = [
  {
    id: 'drama',
    name: '剧情长片',
    description: '以完整叙事为核心的成人向剧情作品，强调人物关系与情绪铺陈，收录都市情感、家庭关系与悬疑叙事等方向。',
    icon: 'ri-film-line',
    children: [
      { id: 'urban', name: '都市情感' },
      { id: 'family', name: '家庭关系' },
      { id: 'mystery', name: '悬疑叙事' },
    ],
  },
  {
    id: 'art',
    name: '艺术影像',
    description: '重视摄影、构图与氛围的实验性创作，包含唯美摄影作品与黑白影像短片。',
    icon: 'ri-image-line',
    children: [
      { id: 'aesthetic', name: '唯美摄影' },
      { id: 'experimental', name: '实验短片' },
      { id: 'monochrome', name: '黑白影像' },
    ],
  },
  {
    id: 'documentary',
    name: '纪实观察',
    description: '以访谈与现场记录为主体的纪实内容，关注行业生态、创作者处境与幕后的真实工作方式。',
    icon: 'ri-mic-line',
    children: [
      { id: 'industry', name: '行业纪实' },
      { id: 'interview', name: '人物访谈' },
    ],
  },
  {
    id: 'retro',
    name: '经典回顾',
    description: '整理上世纪的经典作品与录像带时期的重要片目，附带年代背景与版本说明。',
    icon: 'ri-history-line',
    children: [
      { id: 'golden', name: '黄金年代' },
      { id: 'vhs', name: '录像带时代' },
    ],
  },
  {
    id: 'indie',
    name: '独立制作',
    description: '来自新锐导演与独立团队的小成本作品，包含短片合集与影展入选片目。',
    icon: 'ri-quill-pen-line',
    children: [
      { id: 'new-wave', name: '新锐导演' },
      { id: 'short-set', name: '短片集' },
    ],
  },
  {
    id: 'studio',
    name: '厂牌精选',
    description: '按出品厂牌整理的精选条目，覆盖欧美与亚洲地区较具代表性的制作机构。',
    icon: 'ri-building-2-line',
    children: [
      { id: 'euro', name: '欧美厂牌' },
      { id: 'asia', name: '亚洲厂牌' },
    ],
  },
];

export const regions = ['日本', '韩国', '法国', '意大利', '美国', '英国', '中国台湾', '泰国', '西班牙', '冰岛'];